import React from 'react';
import styles from './DropdownSeparator.module.scss';

export default function DropdownSeparator() {
  return <div className={styles.separator} />;
}
